import React from 'react';
import { SaleTable } from 'components';

export const Sales = () => {
	return <SaleTable />;
};